import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { listEnumData } from '@/api/modules/data'

/**
 * 将数组按指定字段转为映射对象
 */
function toMap(arr, field) {
  if (!arr) return {}
  const map = {}
  arr.forEach((item) => {
    if (item[field] !== undefined && item[field] !== null) {
      map[item[field]] = item
    }
  })
  return map
}

export const useEnumStore = defineStore('enum', () => {
  const enumData = ref({})
  const enumMaps = ref({})
  const enumKeyMaps = ref({})
  const loaded = ref(false)

  /** 加载枚举数据 */
  async function fetchEnumData() {
    if (loaded.value) return

    const data = await listEnumData()
    enumData.value = data

    // 构建映射
    for (const key in data) {
      // 排序
      const sorted = [...data[key]].sort((a, b) => a.code - b.code)
      enumData.value[key] = sorted

      // 按 code 索引的映射
      enumMaps.value[key + '_map'] = toMap(sorted, 'code')

      // 按 key 索引的映射
      enumKeyMaps.value[key + '_key_map'] = toMap(sorted, 'key')
    }

    loaded.value = true
  }

  /**
   * 获取枚举列表
   */
  function getEnumList(enumName) {
    return enumData.value[enumName] || []
  }

  /**
   * 通过 code 获取枚举文本
   */
  function getTextByCode(enumName, code) {
    const map = enumMaps.value[enumName + '_map']
    if (map && map[code]) {
      return map[code].text || ''
    }
    return ''
  }

  /**
   * 通过 key 获取枚举对象
   */
  function getByKey(enumName, key) {
    const map = enumKeyMaps.value[enumName + '_key_map']
    return map ? map[key] : null
  }

  /**
   * 获取 code 映射对象
   */
  function getCodeMap(enumName) {
    return enumMaps.value[enumName + '_map'] || {}
  }

  // 案件特征预定义数据（迁移自 me.global.js）
  const caseFeatures1 = computed(() => [
    { code: 1, text: '单位委托', checked: false },
    { code: 2, text: '个人委托', checked: false },
  ])

  const caseFeatures2 = computed(() => [
    { code: 10, text: '单位委托', checked: false },
    { code: 11, text: '个人委托', checked: false },
    { code: 20, text: '代理原告', checked: false },
    { code: 21, text: '代理被告', checked: false },
    { code: 22, text: '代理第三方', checked: false },
    { code: 30, text: '代理申请人', checked: false },
    { code: 31, text: '代理被申请人', checked: false },
    { code: 32, text: '代理第三方', checked: false },
    { code: 40, text: '代理上诉人', checked: false },
    { code: 41, text: '代理被上诉人', checked: false },
    { code: 42, text: '代理第三方', checked: false },
    { code: 60, text: '代理申请人', checked: false },
    { code: 61, text: '代理被申请人', checked: false },
    { code: 62, text: '代理第三方', checked: false },
    { code: 70, text: '代理嫌疑人（被告人）', checked: false },
    { code: 71, text: '代理受害人', checked: false },
  ])

  return {
    enumData,
    enumMaps,
    enumKeyMaps,
    loaded,
    fetchEnumData,
    getEnumList,
    getTextByCode,
    getByKey,
    getCodeMap,
    caseFeatures1,
    caseFeatures2,
  }
})
